export const AUTH_LOGIN = 'AUTH_LOGIN'
export const AUTH_SUCCESS = 'AUTH_SUCCESS'
export const AUTH_TOKEN_REFRESH = 'AUTH_TOKEN_REFRESH'
export const AUTH_TOKEN_REFRESH_INTERVAL = 'AUTH_TOKEN_REFRESH_INTERVAL'
export const AUTH_ERROR = 'AUTH_ERROR'
export const AUTH_LOGOUT = 'AUTH_LOGOUT'
export const AUTH_PURGE = 'AUTH_PURGE'
export const AUTH_RESET_EMAIL = 'AUTH_RESET_EMAIL'
export const AUTH_RESET_EMAIL_ERROR = 'AUTH_RESET_EMAIL_ERROR'
export const AUTH_RESET_EMAIL_CLEAR = 'AUTH_RESET_EMAIL_CLEAR'
export const AUTH_RESET_REQUEST = 'AUTH_RESET_REQUEST'
export const AUTH_RESET_REQUEST_CLEAR = 'AUTH_RESET_REQUEST_CLEAR'
export const REGISTER = 'REGISTER'
export const CHECK_AUTH = 'CHECK_AUTH'

export const SIGNUP_TOKEN = 'SIGNUP_TOKEN'
export const SIGNUP_TOKEN_ERROR = 'SIGNUP_TOKEN_ERROR'
export const SIGNUP_TOKEN_CLEAR = 'SIGNUP_TOKEN_CLEAR'
export const SIGNUP_TOKEN_REQUEST = 'SIGNUP_TOKEN_REQUEST'
export const SIGNUP_TOKEN_REQUEST_ERROR = 'SIGNUP_TOKEN_REQUEST_ERROR'
export const SIGNUP_TOKEN_REQUEST_SUCCESS = 'SIGNUP_TOKEN_REQUEST_SUCCESS'

export const PASSWORD_RESET = 'PASSWORD_RESET'
export const SSO_LOGIN = 'SSO_LOGIN'
export const PREV_ROUTE = 'PREV_ROUTE'



// WEBPACK FOOTER //
// ./src/store/modules/auth/auth.type.js